import React from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Button } from '@mui/material';

interface Props {
  expanded: boolean;
  onClick: () => void;
}

export default function ToggleDetailsButton({ expanded, onClick }: Props) {
  return (
    <Button
      color="inherit"
      size="small"
      variant="text"
      endIcon={expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      onClick={onClick}
      sx={{ textTransform: 'none' }}
    >
      {expanded ? 'Hide details' : 'Show details'}
    </Button>
  );
}
